import React from 'react';
import { Card } from 'react-bootstrap';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

import uitm from '../../assets/images/contents/UiTM_main.jpg';

export const Contact = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Contact</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item"><a href="/">About</a></li>
        <li class="breadcrumb-item active" aria-current="page">Contact Us</li>
      </ol>
    </nav>
    <h2>Contact Us</h2> <br/>  

    <Card style={{ width: '20rem' }}>
    <Card.Img variant="top" src={uitm} />
    <Card.Body>
      <Card.Title>Institute for Big Data Analytics and Artificial Intelligence<br/></Card.Title>
      <Card.Text>Kompleks Al-Khawarizmi, Universiti Teknologi MARA, <br/>  
                  40450 Shah Alam, Selangor, Malaysia</Card.Text>
                 
    
      <Card.Text>   
        <address>
          Email: <a href="mailto:scds2021@uitm.edu.my">scds2021@uitm.edu.my</a>
        </address> <br/>
      </Card.Text>
    </Card.Body>
  </Card> <br/>
  </div>
)